import { ReactNode } from 'react';

import { TeamMembersProvider } from './TeamMembersContext';
import { WebSocketProvider } from './WebSocket';
import { WebSocketSyncProvider } from './WebSocketSync';
import { ShortcutsProvider } from '../hooks/useKeyboardShortcuts';

export default function PrivateRoutesContext({
  children,
}: Readonly<{ children: ReactNode }>) {
  return (
    <ShortcutsProvider>
      <WebSocketProvider>
        <WebSocketSyncProvider>
          <TeamMembersProvider>{children}</TeamMembersProvider>
        </WebSocketSyncProvider>
      </WebSocketProvider>
    </ShortcutsProvider>
  );
}
